function ThankYou() {
  return (
    <div className="min-h-screen bg-salon-bg flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-md p-8 max-w-md text-center">
        <div className="flex justify-center mb-4">
          <img src="/images/logo-grey.png" alt="Muse & Mane" className="h-16" />
        </div>
        <h1 className="text-2xl font-bold text-gray-800 mb-2">Thank You!</h1>
        <p className="text-gray-600 mb-4">
          Your information has been successfully submitted.
        </p>
        <p className="text-gray-500 text-sm mb-6">
          We look forward to seeing you at your next appointment.
        </p>
        <button
          onClick={() => window.close()}
          className="bg-salon-button text-white px-6 py-2 rounded-md hover:bg-salon-button-hover"
        >
          Close Window
        </button>
      </div>
    </div>
  );
}

export default ThankYou;